import { Skeleton as UiSkeleton, styled } from "@l2r-front/l2r-ui"

export const CampaignListContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const Skeleton = styled(UiSkeleton)(() => ({
    height: 123,
    width: "100%",
    transform: "scale(1)",
}))